import { Box, Button, FormControl, FormGroup, Input } from '@deckee/deck-hand';
import PropTypes from 'prop-types';
import React from 'react';
import useAutoFocus from '../../../hooks/use-auto-focus';

const MyRemindersCreateForm = (props) => {
  const {
    className,
    updateField,
    submit,
    label,
    date,
    showDeleteItemButton,
    deleteItem,
  } = props;

  const nameInputRef = useAutoFocus(); // add input focus

  const handleSubmit = (event) => {
    event.preventDefault();
    submit();
  };

  const formIsValid = label !== '' && date !== '';

  return (
    <Box m={3} className={className}>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <FormControl label="Name" name="name" required>
            <Input
              value={label}
              onChange={(e) => updateField('label', e.target.value)}
              placeholder="Enter a name for this reminder..."
              inputRef={nameInputRef}
            />
          </FormControl>

          <FormControl label="Date" name="date" required>
            <Input
              type="date"
              value={date}
              onChange={(e) => updateField('date', e.target.value)}
            />
          </FormControl>
        </FormGroup>

        <FormGroup>
          <Button.Group wide>
            <Button mb={3} disabled={!formIsValid}>
              Save
            </Button>
          </Button.Group>

          {showDeleteItemButton && (
            <Button.Group wide>
              <Button
                mb={2}
                disabled={!formIsValid}
                onClick={deleteItem}
                onKeyDown={deleteItem}
                variant="ghost"
              >
                Delete
              </Button>
            </Button.Group>
          )}
        </FormGroup>
      </form>
    </Box>
  );
};

MyRemindersCreateForm.propTypes = {
  /** Function triggered when the field updates */
  updateField: PropTypes.func.isRequired,

  /** Function to submit form and add/edit marker */
  submit: PropTypes.func.isRequired,

  /** Do we need to show the delete item buttom */
  showDeleteItemButton: PropTypes.bool,

  /** Function to delete a reminder item */
  deleteItem: PropTypes.func,

  /** Name or title of reminder */
  label: PropTypes.string,

  /** Expirey date of reminder */
  date: PropTypes.string,

  /** Extra classes to pass through */
  className: PropTypes.string,
};

MyRemindersCreateForm.defaultProps = {
  showDeleteItemButton: false,
  deleteItem: undefined,
  label: '',
  date: '',
  className: null,
};

export default MyRemindersCreateForm;
